import { z } from "zod/v4";

export const LivestreamViewedActivityMetadata = z.object({
  viewedAt: z.iso.datetime(),
});
export type LivestreamViewedActivityMetadata = z.infer<typeof LivestreamViewedActivityMetadata>;

export const ClipViewedActivityMetadata = z.object({
  clipId: z.string(),
  viewedAt: z.iso.datetime(),
});
export type ClipViewedActivityMetadata = z.infer<typeof ClipViewedActivityMetadata>;
